module.exports = __webpack_public_path__ + "img/telefoon-icon.937980135d7d44dba92948d36550e313.svg";